var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("div", { staticClass: "col-12 col-md-10" }, [_c("filogix-loader")], 1)
    : _c("filogix-details", {
        ref: "filogixDetails",
        attrs: {
          "filogix-data": _vm.filogixDetails,
          "submit-loading": _vm.submitLoading,
          "allow-save": _vm.allowSave,
        },
        on: { "allow-save": _vm.handleAllowSave, submit: _vm.handleSubmit },
      })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }